// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"movie_wrapper__2uYqv","slide":"movie_slide__2e_2l","movie":"movie_movie__2ruDH"};